const pending = new Map();

function waitForLease(key) {
    return new Promise(resolve => {
        const finish = () => {
            clearTimeout(timer);
            window.removeEventListener('storage', onStorage);
            resolve();
        };
        const onStorage = event => {
            if (event.key === key) finish();
        };
        const timer = setTimeout(finish, 250);
        window.addEventListener('storage', onStorage);
    });
}

async function withLease(selector, operation) {
    const key = `dc-remember-lock-${selector}`;
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    const owner = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    const deadline = Date.now() + 16000;

    while (Date.now() < deadline) {
        let lease;
        try {
            lease = JSON.parse(localStorage.getItem(key));
        } catch {
            lease = null;
        }

        if (!lease || !lease.owner || !Number.isFinite(lease.expiresAt) || lease.expiresAt <= Date.now()) {
            localStorage.setItem(key, JSON.stringify({ owner, expiresAt: Date.now() + 15000 }));
            if (JSON.parse(localStorage.getItem(key))?.owner === owner) {
                try {
                    return await operation();
                } finally {
                    try {
                        if (JSON.parse(localStorage.getItem(key))?.owner === owner) localStorage.removeItem(key);
                    } catch {
                        // An expired or replaced lease belongs to another tab.
                    }
                }
            }
        }

        await waitForLease(key);
    }

    throw new Error('Another tab is signing in. Please retry.');
}

export function withRememberedLoginLock(selector, operation) {
    if (!/^[0-9a-f]{32}$/.test(selector || '')) return Promise.reject(new Error('Invalid saved account.'));
    if (pending.has(selector)) return pending.get(selector);

    const task = Promise.resolve().then(async () => {
        if (!navigator.locks?.request) return withLease(selector, operation);

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 16000);
        try {
            return await navigator.locks.request(`dc-remember-login-${selector}`, { signal: controller.signal }, operation);
        } finally {
            clearTimeout(timeout);
        }
    }).finally(() => pending.delete(selector));
    pending.set(selector, task);
    return task;
}
